module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6TL0RN/tc-custom/9781449420062.jpg?1737755353565",
      "alt": "This image is the cover for the book So Sweet!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("So Sweet!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Fifty fabulously sweet recipes, from cookies to doughnuts, with intriguing flavor combinations from the authority in the kitchen.")]), _c('br'), _c('br'), _vm._v("Gathered inside "), _c('i', [_vm._v("So Sweet!")]), _vm._v(" are fifty mouthwatering baking recipes presented alongside photographs of tasty treats such as Milk Chocolate Toffee Bars, Boston Cream Upside Down Cupcakes, and Strawberry with Lemonade Filling Whoopie Pies, as well as Blueberry Buttermilk Doughnuts with Orange Glaze, Cherry Oatmeal Cookies, and Chocolate-Mint Cupcakes. And just in case you’re uncertain what your sweet tooth is craving, a handy flavor profile reveals whether you’re in the mood for sweet, salty, chocolatey, fruity, or nutty. Remind yourself of the sweeter side of life with "), _c('i', [_vm._v("So Sweet!")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sur La Table\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0